import * as React from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import * as moment from 'moment';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import { api, confirm } from '@src/services/api';
import { _ } from "@src/services/i18n";
import { isReadOnly } from 'services/user';
import { classNames, css, mixin, vars, formatters, defaultProps } from '@src/services/theme';
import { ProtoList, PropsList, StateList, FixUrl } from '@src/components/Proto';
import { Ratio, Box } from '@src/components';
import { Maintenance as Edit } from './MaintenanceEdit';

// typing
interface LocalProps extends PropsList {
    battid?: any;
}

interface LocalState extends StateList {
    next: any;
}

// style
const style = css`
    > footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;

        > * {
            &:first-child {
                font-size: 20px;
                h4 {
                    ${mixin.subTitle}
                }
            }
            &:last-child {
                font-size: 20px;
                > i, > strong {
                    font-size: 44px;
                    padding-right: 10px;
                }
                > i {
                    color: #ccc;
                }
            }
        }
    }
`;

const toolbarStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
`;

// component
export class MaintenanceList extends ProtoList<LocalProps, LocalState> {
    async componentDidMount() {
        const dates = {
            startDate: moment().subtract(14, 'days'),
            // startDate: moment('2018-01-01'),
            endDate: moment()
        };
        const state = {
            ...dates,
            filters: dates
        };
        this.setState(state, () => {
            this.loadWithFilters(state);
        });
    }

    DeleteBtn = () => {
        return row => {
            if (isReadOnly()) return null;
            return (
                <div onClick={(e) => e.stopPropagation()}>
                    <button
                        className="btn btn-success"
                        onClick={(e) => {
                            this.deleteItem(row);
                        } }
                    >
                        {_('maintenancelist_col_delete', 'BatteryLife')}
                    </button>
                </div>
            );
        }
    };

    async deleteItem( row ) {
        try {
            await confirm(_('maintenancelist_col_delete_confirm', 'BatteryLife'));
        } catch(e) {
            return;
        }
        const { urlDelete = "" } = this.props;
        const url = urlDelete;
        const method = "DELETE";
        try {
            const res = await api({
                url: FixUrl(url, row.original.id),
                method
            });
            this.reload()
        } catch(e) {
        }
    }
    
	// render
	render() {
        const _loading = this.loading();
        if (_loading) return _loading;
        const { battid, onBattery } = this.props;
        const { loading, data, next, action, tableProps, editProps, editing, items = [] } = this.state;

        const columns = [
            { Header: _('maintenancelist_col_battery_serialno', 'BatteryLife'), accessor: 'battery.serialno', Cell: (row) => (
                <a className="download" onClick={(e) => { e.stopPropagation(); if (onBattery) onBattery({id: row.original.battery.id}); }}>
                    {row.original.battery.serialno}
                </a>
            ) },
            { Header: _('maintenancelist_col_battery_description', 'BatteryLife'), accessor: 'battery.description' },
            { Header: _('maintenancelist_col_expiration', 'BatteryLife'), id: 'expiration', accessor: v => formatters.date(v.expiration) },
            { Header: _('maintenancelist_col_note', 'BatteryLife'), accessor: 'note' },
            { Header: _('maintenancelist_col_completed', 'BatteryLife'), id: 'completed', accessor: v => formatters.yesNo(v.completed) },
            {
                Header: '',
                accessor: "delete",
                maxWidth: 100,
                Cell: !isReadOnly()?this.DeleteBtn():null,
                sortable: false,
            }
        ];
        
		const toolbar = () => (
            <div className={toolbarStyle}>
            <DateRangePicker {...this.DatePickerProps()} />
                <div>
                    <button className="btn btn-success" onClick={() => this.create()}><i className="fa fa-plus" /> {_('maintenancelist_btn_add', 'BatteryLife')}</button>
                </div>
            </div>
        );
        
        let remains;
        if (next) {
            const now = moment();
            const sch = moment(next.scheduled_at)
            remains = sch.diff(now, 'days');
        }

        let localTableProps;
        if (items) {
            localTableProps = {
                ...defaultProps.table(),
                ...tableProps,
            }
        }
        localTableProps.loading = loading;

        let localEditProps = {
            ...editProps,
            battid,
            cpt: null, get: null
        } as any;
        if (action === "EDIT" && !isReadOnly()) {
            localEditProps = {
                ...localEditProps,
                id: editing,
                item: items.filter(i => i.id === editing)[0],
            };
        }
		return (
            <>
            {(action === "CREATE" || action === "EDIT") && !isReadOnly() &&
            <Edit {...localEditProps} />
            }
            <Box
                title={_('maintenancelist_title', 'BatteryLife')}
                toolbar={toolbar}
                collapsed={false}
            >
                <div className={style}>
                    <ReactTable
                        {...localTableProps}
                        data={items}
                        columns={columns}
                    />
                    {next && (
                    <footer>
                        <div>
                            <h4>{_('maintenancelist_next', 'BatteryLife')}</h4>
                            {next.description}, {formatters.date(next.scheduled_at)}
                        </div>
                        <div>
                            <i className="fa fa-clock-o" />
                            <strong>{remains}</strong>
                            {_('maintenancelist_unit_days', 'BatteryLife')}
                        </div>
                    </footer>
                    )}
                </div>
            </Box>
            </>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryLife/MaintenanceList.tsx